import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import React, { FunctionComponent } from 'react'
import { LightMatchProps } from '../MatchTypes'
import SmallBodyFont from '../../../Theme/Fonts/SmallBody'
import BaseMatchCompetitor from '../HelperClass/MatchCompetitor/BaseMatchCompetitor'
import LinkProps from '../../../Link/LinkProps'

const LightMatch: FunctionComponent<LightMatchProps & LinkProps> = ({
    homeCompetitor,
    awayCompetitor,
    testID,
    webRel,
}) => {
    return (
        <Grid testID={testID} horizontal centerVertical>
            <Grid minWidth={24}>
                <Touchable
                    onPress={homeCompetitor.onPress}
                    href={homeCompetitor.href}
                    expand
                    webRel={webRel}
                >
                    <Grid horizontal minWidth={24} centerVertical alignRight>
                        <BaseMatchCompetitor type="home" resizeMode="contain" {...homeCompetitor} />
                    </Grid>
                </Touchable>
            </Grid>
            <Grid center width={32} noExpand>
                <SmallBodyFont bold>-</SmallBodyFont>
            </Grid>
            <Grid minWidth={24}>
                <Touchable
                    onPress={awayCompetitor.onPress}
                    expand
                    href={awayCompetitor.href}
                    webRel={webRel}
                >
                    <Grid horizontal minWidth={24} centerVertical>
                        <BaseMatchCompetitor type="away" {...awayCompetitor} />
                    </Grid>
                </Touchable>
            </Grid>
        </Grid>
    )
}

export default LightMatch
